import { Customer } from '@/hooks/useApi/types'

export const createCustomer = (overrides?: Partial<Customer>): Customer => ({
    customerId: 1,
    customerName: 'Default Customer',
    configs: {
        baseYearStart: '2020-01-01',
        baseYearEnd: '2020-12-31',
    },
    ...overrides,
})
